import { useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import isEqual from 'lodash/isEqual'

import useSessionSaver from './useSessionSaver'
import { selectCloningStep } from '../reducers/cloning_steps'
import { selectCloneLeaguesSessionData } from '../reducers/session_saver'
import { CloningStepsEnum } from '../constants'
import { resetFilters } from '../reducers/leagues_filter_values'
import { fetchEnhancedLeaguesFromList } from '../reducers/enhanced_leagues'
import { selectSelectedLeaguesForCloning } from '../reducers/selected_leagues_for_cloning'

const useCloningStepsEffects = () => {
  const dispatch = useDispatch()
  const {
    saveSelectedLeaguesToSession,
    saveSessionToServer,
    saveConfigsToSession,
    prePopulateMassDates,
  } = useSessionSaver()

  const selectedLeaguesForCloning = useSelector(selectSelectedLeaguesForCloning)
  const targetLeaguesIDs = selectedLeaguesForCloning.map(league => league.id)

  const cloningStep = useSelector(selectCloningStep)
  const sessionData = useSelector(selectCloneLeaguesSessionData, isEqual)
  const prevStepRef = useRef(cloningStep)
  const pendingSaveRef = useRef(false)

  // Check for step transitions and react accordingly
  useEffect(() => {
    const prevStep = prevStepRef.current
    prevStepRef.current = cloningStep

    if (prevStep === CloningStepsEnum.BROWSE && cloningStep === CloningStepsEnum.RENAME) {
      saveSelectedLeaguesToSession()
      pendingSaveRef.current = true

      // Cleanup after going from the first page
      dispatch(resetFilters())
      dispatch(fetchEnhancedLeaguesFromList(targetLeaguesIDs))
    }

    if (
      (prevStep === CloningStepsEnum.RENAME && cloningStep === CloningStepsEnum.CONFIG) ||
      (prevStep === CloningStepsEnum.RENAME && cloningStep === CloningStepsEnum.BROWSE)
    ) {
      prePopulateMassDates()
      pendingSaveRef.current = true
    }

    if (
      (prevStep === CloningStepsEnum.CONFIG && cloningStep === CloningStepsEnum.DATES) ||
      (prevStep === CloningStepsEnum.CONFIG && cloningStep === CloningStepsEnum.RENAME)
    ) {
      saveConfigsToSession()
      prePopulateMassDates()
      pendingSaveRef.current = true
    }
  }, [ cloningStep ])

  // Persist to server after sessionData has updated from the league save
  useEffect(() => {
    if (pendingSaveRef.current) {
      pendingSaveRef.current = false
      saveSessionToServer()
    }
  }, [ sessionData ])
}

export default useCloningStepsEffects
